module.exports = __webpack_public_path__ + "img/icon-policies.dbab6372.svg";